/**
 * NowAssist Skill Plugin
 *
 * This module exports the NowAssistSkillPlugin which processes
 * NowAssistSkillConfig API calls into ServiceNow records.
 */
import { NowAssistSkillPlugin } from './now-assist-skill-kit/now-assist-skill-plugin'

export { NowAssistSkillPlugin }

export default NowAssistSkillPlugin
